export default "__VITE_ASSET__b4d2f7c9__"